/**
 * @file     analyticsService.ts
 * @purpose  Factory for IAnalyticsService, returns live (GA4 + Relta SDK) when enabled, noop otherwise.
 */
import type { IAnalyticsService } from './analyticsTypes';
import { createNoopAnalyticsService } from './noopAnalyticsService';
import { env } from '@/core/config/env';

/**
 * Creates the analytics service instance.
 * Returns the live GA4 + Relta SDK forwarding service when analytics is enabled,
 * otherwise returns a no-op implementation.
 */
export const createAnalyticsService = (): IAnalyticsService => {
  if (env.enableAnalytics && typeof window !== 'undefined') {
    // Dynamic import keeps the live service out of SSR bundles
    const { createLiveAnalyticsService } = require('./liveAnalyticsService') as typeof import('./liveAnalyticsService');
    return createLiveAnalyticsService();
  }
  return createNoopAnalyticsService();
};
